import {ReactNode} from 'react'
import {Form as AntdForm, FormProps as AntdFormProps} from 'antd'

interface FormProps extends AntdFormProps {
  children: ReactNode
}

const validateMessages = {
  required: '',
  types: {
    email: 'Not a valid email',
  },
}

const formOptions: AntdFormProps = {
  validateMessages,
  colon: false,
  requiredMark: false,
  scrollToFirstError: true,
  validateTrigger: 'onChange',
  layout: 'vertical',
  autoComplete: 'off',
}

export default function Form({children, ...props}: FormProps) {
  return (
    <AntdForm {...formOptions} {...props}>
      {children}
    </AntdForm>
  )
}
